/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Rapat_S1Inputs */

const en_tut_rapat_s1 = /** @type {(inputs: Tut_Rapat_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open **Meeting**, press **Buat meeting**, fill in **Judul meeting** and **Agenda**, then choose who is invited (members or divisions). Fill in **Jadwal (opsional)** if it is scheduled.`)
};

const id_tut_rapat_s1 = /** @type {(inputs: Tut_Rapat_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka **Meeting**, tekan **Buat meeting**, isi **Judul meeting** dan **Agenda**, lalu pilih siapa yang diundang (anggota atau divisi). Isi **Jadwal (opsional)** kalau memang dijadwalkan.`)
};

/**
* | output |
* | --- |
* | "Open **Meeting**, press **Buat meeting**, fill in **Judul meeting** and **Agenda**, then choose who is invited (members or divisions). Fill in **Jadwal (opsi..." |
*
* @param {Tut_Rapat_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_rapat_s1 = /** @type {((inputs?: Tut_Rapat_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Rapat_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_rapat_s1(inputs)
	return en_tut_rapat_s1(inputs)
});